/**
 * @module validator
 */

/**
 * validate a string is valid google tag manager id or not.
 */
export function isGTMId(arg: string) {
	return /^GTM-[0-9A-Z]{6,}$/.test(arg);
}
